import {ucwords, saveCSV} from '@/utils/utils';
// const debounce = require('debounce');
const _ = require('lodash');

export default {
  mounted() {
    window.addEventListener('resize', this.upWindowHeight);
    // this.debounceScrollbar = debounce(this.updateScrollbar, 300);
  },
  destroyed() {
    window.removeEventListener('resize', this.upWindowHeight);
  },
  methods: {
    showDonorSidebar(donorId) {
      this.showDonorInfo = false;
      this.showDonorId = false;

      this.$nextTick(() => {
        this.showDonorInfo = true;
        this.showDonorId = donorId;
      });
    },
    getDonationTypeTitle(donationType) {
      let type = ucwords(donationType.replace('-', ' '));
      if (donationType === 'custom') {
        type = 'One-Time';
      } else if (donationType === 'recurring') {
        type = 'Monthly';
      } else if (donationType === 'roundup') {
        type = 'Round-Up';
      }
      return type;
    },
    exportData(type, title, header, body, columnStyles = null) {
      if (type === 'pdf') {
// eslint-disable-next-line
        let doc = new jsPDF('landscape');
        doc.text(title, 15, 20);

        doc.autoTable({
          head: [header],
          body,
          columnStyles,
          margin: {top: 25},
        });
        doc.save(`${title}.pdf`);
      } else {
        saveCSV(
          [
            [title],
            header,
            ...body,
          ],
          {
            filename: `${title}.csv`,
            addHeader: false,
          },
        );
      }
    },
    upWindowHeight() {
      this.wHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    },
    updatePage() {
      this.currentPage = 1;
    },
    handleSortChange(sorting) {
      this.sorting = sorting;
    },
    donationsFillCampaigns(donationsData, allCampaigns) {
      return donationsData.map(donation => {
        donation['campaign'] = '';

        if (allCampaigns.length && donation.campaign_id) {
          const cmp = allCampaigns.find(c => Number(c.id) === Number(donation.campaign_id));

          if (cmp) {
            donation['campaign'] = cmp.name;
          }
        }

        return donation;
      });
    },
  },
  computed: {
    tableHeight() {

      let res = this.wHeight - 424;
      if(res < 200){
        res = 200;
      }

      return res;
    },
    itemsDataSorted() {
      if(!this.itemsData || !this.itemsData.length){
        return [];
      }

      if(!this.sorting.prop){
        return this.itemsData;
      }
      let itemsData = JSON.parse(JSON.stringify(this.itemsData));

      itemsData = itemsData.sort((a, b) => {

        let val1 = a.hasOwnProperty(this.sorting.prop) ? a[this.sorting.prop] : '';
        let val2 = b.hasOwnProperty(this.sorting.prop) ? b[this.sorting.prop] : '';

        if (this.sorting.prop === '_full_name') {
          val1 = `${a.first_name} ${a.last_name}`;
          val2 = `${b.first_name} ${b.last_name}`;
        }
        else if (this.sorting.prop === '_donor_full_name') {
          val1 = `${a.donor.first_name} ${a.donor.last_name}`;
          val2 = `${b.donor.first_name} ${b.donor.last_name}`;
        }
        else if(this.sorting.prop.split('.').length){
          val1 = _.get(a, this.sorting.prop);
          val2 = _.get(b, this.sorting.prop);
        }

        if (typeof val1 !== typeof val2) {
          if(val1 === null && _.isString(val2)){
            val1 = ''
          }
          else if(val2 === null && _.isString(val1)){
            val2 = '';
          }
          else {
            // eslint-disable-next-line
            console.warn('sorting error, types mismatch');
            return 0;
          }
        }

        switch (typeof val1) {
          case 'number':
            return val1 - val2;
          case 'boolean':
            return val1 === val2 ? 0 : val1 ? 1 : -1;
          case 'string':
            return val1.localeCompare(val2);
          default:
            return 0;
        }
      });

      if (this.sorting.order === 'descending') {
        return itemsData.reverse();
      }
      return itemsData;
    },
    itemsDataPage() {
      const startIndex = this.paginationInfo.pageSize * (this.currentPage - 1);
      return this.itemsDataSorted.slice(startIndex, startIndex + this.paginationInfo.pageSize);
    },
  },
  watch:{
    currentPage(){
      document.querySelector('.el-table__body-wrapper').scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }
  },
  data() {
    return {
      // debounceScrollbar: null,
      wHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
      shownPagination: true,
      currentPage: 1,
      loading: false,
      sorting: {prop: 'created_at', order: 'descending'},
      paginationInfo: {pageSize: 50,
        // nextPageText: '▶', prevPageText: '◀'
      },
      showDonorInfo: false,
      showDonorId: null,
    };
  },
};
